import { Box, Container, Grid, Paper, Step, StepLabel, Stepper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import WorkIcon from '@material-ui/icons/Work';
import { Title } from 'app/components';
import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import { SelectType, SelectCase, ScreenParams } from './components';
import { useRouter } from 'app/utils';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3, 3, 8),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 2, 6),
    },
  },
  stepper: {
    backgroundColor: 'transparent',
    '& .MuiStepConnector-vertical': {
      padding: 0,
    },
  },
}));

const steps = [
  {
    label: 'Screen Type',
    icon: WorkIcon,
  },
  {
    label: 'Case Assignment',
    icon: WorkIcon,
  },
  {
    label: 'Screen Parameters',
    icon: WorkIcon,
  },
];

const DEFAULT_INPUTS = {
  type: 'person',
  caseName: null,
  newCase: true,
  caseId: null,
  params: {},
};

const NewScreening = (props) => {
  const { children, className, ...rest } = props;
  const classes = useStyles();
  const router = useRouter();
  const caseRef = new URLSearchParams(router.location.search).get('case');
  // eslint
  const [activeStep, setActiveStep] = useState(0);
  const [inputs, setInputs] = useState({
    ...DEFAULT_INPUTS,
    params: { ...DEFAULT_INPUTS.params },
  });
  useEffect(() => {
    if (caseRef) {
      if (inputs.newCase) setInputs({ ...inputs, newCase: false });
    }
    // eslint-disable-next-line
  }, []);

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Box {...rest} className={clsx(classes.root, className)}>
      <Title prefix="Create Screening" />

      <Container maxWidth="lg">
        <Paper>
          <Grid container>
            <Grid item xs={12} md={3}>
              <Stepper activeStep={activeStep} className={classes.stepper} orientation="vertical">
                {steps.map((step, index) => (
                  <Step key={index}>
                    <StepLabel>{step.label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Grid>
            <Grid item xs={12} md={9}>
              <Box p={3}>
                {activeStep === 0 && <SelectType screen_type={inputs.screen_type} onSelect={(screen_type) => setInputs({ ...inputs, screen_type })} onNext={handleNext} />}
                {activeStep === 1 && (
                  <SelectCase
                    newCase={inputs.newCase}
                    caseId={inputs.caseId}
                    onToggleCase={(newCase) => setInputs({ ...inputs, newCase })}
                    caseName={inputs.caseName}
                    onSelect={(caseId) => setInputs({ ...inputs, caseId })}
                    onNameInput={(caseName) => setInputs({ ...inputs, caseName })}
                    onBack={handleBack}
                    onNext={handleNext}
                  />
                )}
                {activeStep === 2 && <ScreenParams type={inputs.screen_type} newCase={inputs.newCase} caseId={inputs.caseId} caseName={inputs.caseName} onBack={handleBack} />}
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    </Box>
  );
};

export default NewScreening;
